import axios from "axios";
// Entities
import { Stock, StocksFields } from "@/entities/index";

export async function getStocks({
  client,
  integrateStepZero,
  optionPalette,
  userId,
  stocksFields,
}: {
  client: string;
  integrateStepZero: boolean;
  optionPalette: boolean;
  userId: number;
  stocksFields: StocksFields;
}): Promise<Stock[]> {
  const stocks = (
    await axios.post(`/api/stocks`, {
      client,
      integrateStepZero,
      optionPalette,
      reference: stocksFields.reference,
      palletNumber: stocksFields.palletNumber,
      designation: stocksFields.designation,
      family: stocksFields.family,
      warehouse: stocksFields.warehouse,
      lot: stocksFields.lot,
    })
  ).data as Stock[];
  stocks.forEach((stock) => {
    if (stock.warehouse === "SAV") {
      stock.warehouse = "TL89";
    } else if (stock.warehouse === "CHA") {
      stock.warehouse = "Chalon";
    }
  });
  await axios.post("/api/stats/action", {
    userId,
    action: "Recherche de Stock",
  });

  return stocks;
}
